export default {
  //get all SUBJECTs
  GET_SYSTEM_SUBJECTS_REQUEST: "GET_SYSTEM_SUBJECTS_REQUEST",
  GET_SYSTEM_SUBJECTS_SUCCESS: "GET_SYSTEM_SUBJECTS_SUCCESS",
  GET_SYSTEM_SUBJECTS_FAIL: "GET_SYSTEM_SUBJECTS_FAIL",

  //loading
  ADD_SUBJECTS_LOADING: "ADD_SUBJECTS_LOADING",
};
